import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { BadgeStatusService } from '../../badge-status.service';
import { RoleServiceFactoryService } from '../../services/role-service-factory.service';

@Component({
  selector: 'app-avatar-fallback-name-grade-widget',
  templateUrl: './avatar-fallback-name-grade-widget.component.html',
  styleUrls: ['./avatar-fallback-name-grade-widget.component.scss'],
})
export class AvatarFallbackNamegradeWidgetComponent implements OnInit, OnDestroy {
  @Input() instructorName: string;
  @Input() instructorEmail: string;
  @Input() instructorEmployeeId: string;
  @Input() role: string = null;
  @Input() showRole: boolean = true;
  @Input() fixIndicatorPos: boolean = false;

  teacherAvatar: string = '/assets/img/icons/teacher.svg';
  quietSettings: any = null;
  badgeSubscription: Subscription;

  constructor(
    private badgeStatusService: BadgeStatusService,
    public rs: RoleServiceFactoryService
  ) { }

  get userId(): string {
    return this.instructorEmployeeId ? this.instructorEmployeeId + 'TCH' : null;
  }

  get name(): string {
    return this.instructorName || 'N/A';
  }

  ngOnInit(): void {
    if (this.role === this.rs.TeacherRole && this.instructorEmployeeId) {
      this.badgeSubscription = this.badgeStatusService
        .trackStatus(this.userId)
        .subscribe((settings) => {
          this.quietSettings = settings;
        });
    }
  }

  ngOnDestroy(): void {
    if (this.badgeSubscription) {
      this.badgeSubscription.unsubscribe();
    }
  }
}
